import "./CaregiverServicePagesPage2.module.css";
import Header from "@/reusable_sections/Header";
import Introduction from "./sections/Introduction";
import ServicesSummary from "./sections/ServicesSummary";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function CaregiverServicePagesPage2() {
  return <div>
      <Header />
      <Introduction />
      <ServicesSummary />
      <CallToAction />
      <Footer />
    </div>;
}